import { Workflow } from 'shared/types/workflow';

import { WorkflowDetailType } from './types';

const validator = (values: WorkflowDetailType, workflowList: Workflow[]) => {
  if (!values.name) {
    return 'Type workflow name to continue.';
  } else {
    const found = workflowList.find(({ name }) => (
      // We make both names lowercase, because workflow names are case-insensitive.
      name.toLowerCase() === values.name.toLowerCase()
    ));

    if (found) {
      return 'The selected workflow name already exists.';
    }
  }

  if (!values.type) {
    return 'Select a workflow type to continue.';
  }
};

export default validator;
